'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseZonedIntervalViewModel=require('./baseZonedIntervalViewModel');let

TripViewModel=function(_BaseZonedIntervalVie){_inherits(TripViewModel,_BaseZonedIntervalVie);
function TripViewModel(jsonTrip){_classCallCheck(this,TripViewModel);var _this=_possibleConstructorReturn(this,
_BaseZonedIntervalVie.call(this,jsonTrip));
_this._origin=jsonTrip.origin;
_this._destination=jsonTrip.destination;

if(_.exists(jsonTrip.tod)){
_this._tod=jsonTrip.tod;
}

if(_.exists(jsonTrip.metadata)){
_this._metadata=jsonTrip.metadata;
}return _this;
}_createClass(TripViewModel,[{key:'origin',get:function()

{
return this._origin;
}},{key:'destination',get:function()

{
return this._destination;
}},{key:'tod',get:function()

{
return this._tod;
}},{key:'metadata',get:function()

{
return this._metadata;
}}]);return TripViewModel}(BaseZonedIntervalViewModel);


module.exports=TripViewModel;
//# sourceMappingURL=tripViewModel.js.map
